import {
  drawAngleAnim,
  drawCircleAnim,
  drawLineAnim,
  drawPointsAnim,
  movePointAnim
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";
import { CIRCLE_COLORS, INITIAL_TRIANGLE_RADIANS } from "../../types/Config";
import { ContextType } from "../../types/Interface";


export async function runCircleAnimation(context: ContextType, onComp: () => void) {
  const {
    circle,
    PointManager,
    LineManager,
    AngleManager,
    cCoord,
  } = context;

  const sltdTPIndex = PointManager.getSltdTPointIndex();
  const PointsCoord = PointManager.getRedPointsCoord();
  const TPointsCoord = PointManager.getTangentCoords();
  const circlePoint = PointManager.getPoints()[0];
  const RedPoints = PointManager.getRedPoints();


  circle.draw({ radius: circle.radius, radians: Array(3).fill(INITIAL_TRIANGLE_RADIANS[0] - 2 * Math.PI) })
  await drawPointsAnim([circlePoint])
  await drawCircleAnim(circle, INITIAL_TRIANGLE_RADIANS[0], 0, true, cCoord);

  await drawLineAnim(LineManager.triangle[0], PointsCoord[0], PointsCoord[1]);
  await drawLineAnim(LineManager.triangle[1], PointsCoord[1], PointsCoord[2]);
  await drawLineAnim(LineManager.triangle[2], PointsCoord[2], PointsCoord[0]);
  await drawLineAnim(LineManager.tangent, TPointsCoord[0], TPointsCoord[1]);

  circle.radians = Array(3).fill(INITIAL_TRIANGLE_RADIANS[0]);
  await drawCircleAnim(circle, INITIAL_TRIANGLE_RADIANS[1], 2, false, cCoord);

  LineManager.setIsShowSecondSegment(false);
  LineManager.draw(PointsCoord, TPointsCoord, sltdTPIndex);
  drawAngleAnim(AngleManager.circumAnglePink, "p");
  await drawAngleAnim(AngleManager.alternativeAnglePink, "p");

  circle.setColors([CIRCLE_COLORS[2], CIRCLE_COLORS[1], CIRCLE_COLORS[2]])

  await movePointAnim(INITIAL_TRIANGLE_RADIANS[2], INITIAL_TRIANGLE_RADIANS[2] + Math.PI / 8, (radian) => PointManager.setRadian([{ pTag: RedPoints[2].tag, radian }]));
  await movePointAnim(INITIAL_TRIANGLE_RADIANS[2] + Math.PI / 8, INITIAL_TRIANGLE_RADIANS[2], (radian) => PointManager.setRadian([{ pTag: RedPoints[2].tag, radian }]));

  circle.radians = [INITIAL_TRIANGLE_RADIANS[0], INITIAL_TRIANGLE_RADIANS[0], INITIAL_TRIANGLE_RADIANS[1]]
  circle.setColors(CIRCLE_COLORS);

  await drawCircleAnim(circle, Math.PI - INITIAL_TRIANGLE_RADIANS[1], 0, false, cCoord);

  LineManager.setIsShowSecondSegment(true);
  LineManager.draw(PointsCoord, TPointsCoord, sltdTPIndex);
  drawAngleAnim(AngleManager.circumAngleBlue, "b");
  await drawAngleAnim(AngleManager.alternativeAngleBlue, "b");

  await movePointAnim(INITIAL_TRIANGLE_RADIANS[1], INITIAL_TRIANGLE_RADIANS[1] + Math.PI / 8, (radian) => PointManager.setRadian([{ pTag: RedPoints[1].tag, radian }]));
  await movePointAnim(INITIAL_TRIANGLE_RADIANS[1] + Math.PI / 8, INITIAL_TRIANGLE_RADIANS[1], (radian) => PointManager.setRadian([{ pTag: RedPoints[1].tag, radian }]));


  onComp();
}
